var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BRow',[_c('BCol',{attrs:{"md":"6"}},[_c('TheDebtor')],1),_c('BCol',{attrs:{"md":"6"}},[_c('TheLoan'),_c('TheDebtObligation'),_c('TheSuccession'),_c('TheBankrupt')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }